__webpack_require__.p = "https://teccom-portal-demo.azurewebsites.net/";